import axios from "axios";
import BASE_URL from "../../../../../assets/global/url";
import { fetchPagedWithDetails } from "../../../../../utils/export/batchFetch";
import { renderPdfInWorker } from "../../../../../utils/export/pdfWorker";
import InvoicePdf from "./InvoicePdf";
import exportInvoiceExcel from "./invoiceExcel";

// Export config for ExportOptionsModal (see components/Export).

const PAGE_SIZE = 200;

// Same status grouping the tabs use
const STATUSES = [
  { value: "Pending", label: "Pending", includes: ["Pending"] },
  {
    value: "Approved",
    label: "Approved",
    includes: ["Approved", "Partially Collected", "Collected"],
  },
  { value: "Returned", label: "Returned", includes: ["Returned"] },
];

function toExportInvoice(row, detail) {
  return {
    sales_invoice_id: row.sales_invoice_id,
    client_transaction_id: row.client_transaction_id,
    invoice_date: row.invoice_date,
    due_date: detail?.due_date,
    dr_number: row.dr_number,
    total_amount: row.total_amount,
    currency_name: row.currency?.currency_name || row.currency_name || "PHP",
    customer: row.customer,
    items: detail?.items || [],
  };
}

async function fetchRecords({
  status,
  startDate,
  endDate,
  filters,
  signal,
  onProgress,
}) {
  const { includes } = STATUSES.find((s) => s.value === status);

  const { rows, details } = await fetchPagedWithDetails({
    recordLabel: "invoices",
    signal,
    onProgress,
    fetchPage: async (page) => {
      const res = await axios.get(`${BASE_URL}/invoice/getSalesData`, {
        params: {
          startDate,
          endDate,
          status: includes.length > 1 ? includes : includes[0],
          currencyId: filters?.currencyId,
          limit: PAGE_SIZE,
          page,
          // Stable key so rows can't shift between pages mid-export
          sortBy: "sales_invoice_id",
          sortDirection: "ASC",
        },
        signal,
      });
      return { rows: res.data.data, totalPages: res.data.totalPages };
    },
    fetchDetails: async (batch) => {
      const res = await axios.post(
        `${BASE_URL}/invoice/getInvoiceExportDetails`,
        { ids: batch.map((row) => row.sales_invoice_id).filter(Boolean) },
        { signal },
      );
      return res.data || {};
    },
  });

  // Fetched by id for stable paging; present them latest invoice date first
  rows.sort((a, b) =>
    String(b.invoice_date || "").localeCompare(String(a.invoice_date || "")),
  );
  return rows.map((row) => toExportInvoice(row, details[row.sales_invoice_id]));
}

const invoiceExportConfig = {
  title: "Invoice",
  recordLabel: "invoices",
  statuses: STATUSES,
  fetchRecords,
  renderPdf: ({ records, meta, signal }) =>
    renderPdfInWorker({
      createWorker: () =>
        new Worker(new URL("./invoicePdf.worker.jsx", import.meta.url)),
      Document: InvoicePdf,
      props: { records, meta },
      signal,
    }),
  exportExcel: exportInvoiceExcel,
};

export default invoiceExportConfig;
